import { useCallback, useContext, useEffect, useMemo, useRef, useState, type ChangeEvent } from 'react';
import { useForm } from 'react-hook-form';
import useOffer from '../../../api/hooks/useOffers';
import LogMessage from '../../../components/misc/LogMessage';
import MyNavigator from '../../../components/misc/MyNavigator';
import NavBar from '../../../components/misc/NavBar';
import SideBar from '../../../components/misc/SideBar';
import MainContext from '../../../context/MainContext';
import useIsMobile from '../../../hooks/useIsMobile';
import useLogMessage from '../../../hooks/useLogMessage';
import useToggle from '../../../hooks/useToggle';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../components/inputs/CustomInput';
import DragAndDropImages from '../../../components/inputs/DragAndDropImages';
import useCategory from '../../../api/hooks/useCategory';
import Select from 'react-select';
import Loader from '../../../components/Loader';
import useConditions from '../../../api/hooks/useConditions';
import useVendors from '../../../api/hooks/useVendors';
import CustomModal from '../../../components/modals/CustomModal';
import 'react-quill/dist/quill.snow.css'; 
import ReactQuill from 'react-quill';
import SimpleImageSlider from 'react-simple-image-slider';
import { Category } from '../../../api/hooks/useCategory';
import { Checkbox } from '@mui/material';



const OfferDetailsPage = (props: any) => {
    const { isMobile } = useIsMobile();
    const { user } = useContext(MainContext);
    // const navigate = useNavigate();
    const { sku } = useParams();
    // const navigate = useNavigate();
    // const navigate = useNavigate();
    const navigateNow = useToggle(false);
    const menuToggler = useToggle(false);
    const logMessage = useLogMessage();
    const formRef = useRef<HTMLFormElement | null>(null);

    const { RESPONSES, RESULTS, CTAs } = useOffer();
    const { RESPONSES: RESPONSEcatgeory, RESULTS: RESULTcatgeory, CTAs: CTAsCategory } = useCategory();
    const { RESPONSES: RESPONSEConditions, RESULTS: RESULTConditions, CTAs: CTAsConditions } = useConditions();
    const { RESPONSES: RESPONSEvendors, RESULTS: RESULTvendors, CTAs: CTAsVendors } = useVendors();

    const [product, setProduct] = useState<any>(undefined);
    const [paymentRules, setPaymentRules] = useState([]);
    const [returnRules, setReturnRules] = useState([]);
    const [categories, setCategories] = useState<any[]>([]);
    const [sites, setSites] = useState<any[]>([]);
    const [movements, setMovements] = useState<any[]>([]);
    const [conditions, setConditions] = useState<any>([]);
    const [popupMovements, setPopupMovements] = useState(false);
    const [load, setLoad] = useState(1);
    const [closePage, setClosePage] = useState(false);
    const [longDescription , setLongDescription] = useState<string>('');
    /** Quill non supporta <table>: con HTML ricco usiamo textarea + anteprima. */
    const [descriptionEditorMode, setDescriptionEditorMode] = useState<'rich' | 'html'>('rich');
    const descriptionModeInitSkuRef = useRef<string | null>(null);
    const [selectedCategory, setSelectedCategory]= useState<{value:number,label:string}>();

    const [isLoadingMovements, setIsLoadingMovements] = useState(false);
    const [isSavingProduct, setIsSavingProduct] = useState(false);
    const [isCloningProduct, setIsCloningProduct] = useState(false);
    const [isDeletingProduct, setIsDeletingProduct] = useState(false);
    const [quantity, setQuantity]=useState<number>(0);

    const [suppliers, setSuppliers]=useState<any[]>([]);
    const [selectedSupplier, setSelectedSupplier]= useState<{value:number,label:string}>();
    const [vendors, setVendors] = useState<{ value: number; label: string }[]>([]);
    const [selectedVendor, setSelectedVendor] = useState<{ value: number; label: string } | null>(null);
   
    const tempLoading = useToggle(false);

    const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'Europe/Rome',
        timeZoneName: 'short',
    };


    const CustomStyle = {
        option: (base: any, state:any) => ({
          ...base,
          backgroundColor: state.isSelected ? 'green' : 'white',
        }),
        control: (base: any) => ({
            ...base,
            width: "max-content",
            minWidth: "100%"
       }),
       menu: (base: any) => ({
        ...base,
        width: "max-content",
        minWidth: "100%",
        padding: 0,
        margin: 0
   }),
      }



      useEffect(() => {
        CTAs.getProductDetails(sku!);
        CTAs.getReturnRules();
        CTAs.getPaymentRules();
        CTAs.getSites();
        CTAs.getMovements(sku!);
        CTAs.getSuppliers();
        CTAsCategory.getCategory();
        CTAsConditions.getConditions();
        CTAsVendors.getVendors();
    }, []);

    useEffect(() => {
        CTAs.getMovements(sku!);
    }, [RESPONSES.updateMovementsResponse])
  

    useEffect(() => {
        if (RESPONSES.getProductDetailsResponse?.ok) {
            setProduct(RESULTS.getProductDetailsResult);
            setQuantity(RESULTS.getProductDetailsResult.quantity);
            setSelectedSupplier(RESULTS.getProductDetailsResult.suppliers && RESULTS.getProductDetailsResult.suppliers.length>0 ? {value:RESULTS.getProductDetailsResult.suppliers[0].id, label:RESULTS.getProductDetailsResult.suppliers[0].cod} : {value:-1,label:'Seleziona'});
            const descRaw = RESULTS.getProductDetailsResult.long_description;
            const desc = descRaw == null || descRaw === undefined ? '' : String(descRaw);
            setLongDescription(desc);
            editProductForm.setValue('long_description', desc);
            if (descriptionModeInitSkuRef.current !== sku) {
                descriptionModeInitSkuRef.current = sku ?? null;
                setDescriptionEditorMode(/<table[\s>]/i.test(desc) ? 'html' : 'rich');
            }
            editProductForm.setValue('category_id', RESULTS.getProductDetailsResult.category?.id);
            setSelectedCategory({value:RESULTS.getProductDetailsResult.category?.id, label:RESULTS.getProductDetailsResult.category?.name});
            const res = RESULTS.getProductDetailsResult;
            const v = res.vendor;
            const vendorId = v?.id ?? res.vendor_id;
            if (vendorId) {
                editProductForm.setValue('vendor_id', vendorId);
                setSelectedVendor({ value: Number(vendorId), label: v?.name || v?.code || `Vendor ${vendorId}` });
            } else {
                editProductForm.setValue('vendor_id', null);
                setSelectedVendor(null);
            }
        }
        // console.log(RESULTS.getProductDetailsResult);
    }, [RESULTS.getProductDetailsResult, RESPONSES.getProductDetailsResponse, product]);

    const publishedOptions = [
        {
            name: 'Pubblicato',
            id: 1,
        },
        {
            name: 'Bozza',
            id: 0,
        },
    ];

    const editProductForm = useForm();
    const editMovementsForm = useForm();

    const sitesValues = editProductForm.watch('sites');

    const deleteProduct = () => {
        setIsDeletingProduct(true);
        CTAs.deleteProduct(sku!);
    };

    useEffect(() => {
        if (RESPONSES.deleteProductResponse?.ok) {
            // navigate('/offers');
            setIsDeletingProduct(false);
            const queryParams = new URLSearchParams(window.location.search);
            window.location.href = `/offers?${queryParams.toString()}`;
        }
        if (RESPONSES.cloneProductResponse?.ok) {
            setIsCloningProduct(false);
            const queryParams = new URLSearchParams(window.location.search);
            window.location.href = `/offers/${RESULTS.cloneProductResult.product.SKU}?${queryParams}`;
            // navigate(`/offers`);
        }
    }, [RESPONSES.deleteProductResponse, RESPONSES.cloneProductResponse, RESULTS.cloneProductResult]);

    const cloneProduct = async () => {
        try {
            setIsCloningProduct(true);
            await CTAs.cloneProduct(sku!);
            setIsCloningProduct(false);
        } catch (error) {
            console.error(error);
            setIsCloningProduct(false);
        }
    };

    const onProductSubmit = (data: any, event: any) => {

        if (isNaN(data.final_price)) {
            alert("ERRORE: il prezzo inserito non è valido!");
        } else if (isNaN(data.waist)) {
            alert("ERRORE: il peso inserito non è valido!");
        } else {
            tempLoading.setIsToggled(true);
            setIsSavingProduct(true);


            if (event.nativeEvent.detail?.close) {
                setClosePage(event.nativeEvent.detail.close);
            }

            const selectedSites = Object.keys(data.sites)
                .filter((key) => data.sites[key])
                .map((key) => ({ id: parseInt(key, 10) }));
            const formattedData = {
                ...data,
                sites: selectedSites,
                images: data.images.map((item: any) => ({
                    filename: item.filename,
                    ordering: item.ordering,
                    base64: item.base64,
                })),
            };
            CTAs.changePublishProduct(sku!, data.published, formattedData);
        }
    };

    useEffect(() => {
        console.log(RESPONSES.publishedProductResponse);
        if (RESPONSES.publishedProductResponse?.ok) {
            console.log(RESULTS.publishedProductResult);
            setIsSavingProduct(false);
            if (closePage) {
                const queryParams = new URLSearchParams(window.location.search);
                window.location.href = `/offers?${queryParams.toString()}`;
            }
        }else{
            console.log(RESPONSES.publishedProductResponse?.code);
        }
    }, [RESPONSES.publishedProductResponse, RESULTS.publishedProductResult, closePage]);

    const onMovementsSubmit = (data: any) => {

        console.log("SUBMIT MOVEMENTS!")
        tempLoading.setIsToggled(true);
        setIsLoadingMovements(true);
        setQuantity(quantity+Number.parseInt(`${load === 0 ? '-' : '+'}${data.quantity}`));

        CTAs.updateMovements(sku!, `${load === 0 ? '-' : '+'}${data.quantity}`, data.notes);
        // console.log(data);
        // console.log(RESULTS.updateMovementsResult);
    };

    useEffect(() => {
        if (product) {
            product.sites.forEach((site: any) => {
                editProductForm.setValue(`sites.${site.id}`, true);
            });
            
        }
    }, [product, editProductForm.setValue]);

    useEffect(() => {
        if (RESPONSES.updateMovementsResponse?.ok) {
            // console.log(RESULTS.updateMovementsResult);
            //
            tempLoading.setIsToggled(false);
            setIsLoadingMovements(false);
            editMovementsForm.reset();
            setPopupMovements(false);

            console.log("UPDATE MOVEMENTS 200!");

        }
    }, [RESPONSES.updateMovementsResponse]);

    useEffect(() => {
        /* console.log(RESPONSES.getListAllResponse, RESULTS.getListAllResult); */
        if (RESPONSES.paymentRulesResponse?.ok) {
            setPaymentRules(
                RESULTS.paymentRulesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                }))
            );
        }

        if (RESPONSES.returnRulesResponse?.ok) {
            setReturnRules(
                RESULTS.returnRulesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                }))
            );
        }

        if (RESPONSES.getSitesResponse?.ok) {
            setSites(
                RESULTS.getSitesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.site,
                }))
            );
        }

        if (RESPONSES.getMovementsResponse?.ok) {
            setMovements(RESULTS.getMovementsResult.movements);
            setIsLoadingMovements(false);

        }

        if (RESPONSEcatgeory.getCategoriesResponse?.ok) {
            setCategories(
                RESULTcatgeory.getCategoriesResult.map((item: any) => ({
                    value: Number(item.id),
                    label: item.name,
                }))
            );
        }

        if (RESPONSEConditions.getConditionsResponse?.ok) {
            setConditions([
                {
                    name: 'Seleziona',
                },
                ...RESULTConditions.getConditionsResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);

        }


        if (RESPONSES.getSuppliersResponse?.ok) {
            setSuppliers([
                {
                    label: 'Seleziona',
                    value:-1,
                },
        
                ...RESULTS.getSuppliersResult.map((item: any) => ({
                    value: Number(item.id),
                    label: item.cod,
                })),
            ]);
        }

        if (RESPONSEvendors.getVendorsResponse?.ok && RESULTvendors.getVendorsResult) {
            const list = Array.isArray(RESULTvendors.getVendorsResult) ? RESULTvendors.getVendorsResult : [];
            setVendors(list.map((v: any) => ({ value: Number(v.id), label: v.name || v.code || `Vendor ${v.id}` })));
        }

        editProductForm.clearErrors();
    }, [
        RESPONSES.paymentRulesResponse,
        RESPONSES.returnRulesResponse,
        RESPONSES.getSitesResponse,
        RESPONSES.getMovementsResponse,
        RESPONSEcatgeory.getCategoriesResponse,
        RESPONSEConditions.getConditionsResponse,
        RESPONSES.getSuppliersResponse,
        RESPONSEvendors.getVendorsResponse,
        RESULTvendors.getVendorsResult,
    ]);

    useEffect(()=>{
        //alert(RESULTS.addSupplierToProductResult);
    },[RESPONSES.addSupplierToProductResponse]);

    // const updateSite = (siteId: number) => {
    //     CTAs.updateSite(sku!, siteId);
    //     console.log(RESULTS.editSitesResult);
    // };

    // console.log(RESULTS.getProductDetailsResult);

    const handleChangeContoVendita = (select: any) => {
        setSelectedSupplier(select);
        CTAs.addSupplierToProduct(sku!,select.value);
    };

    const handleDescriptionChange = (value: string) => {
        setLongDescription(value);
        editProductForm.setValue('long_description', value);
    };

    const handleRawDescriptionChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const value = event.target.value;
        setLongDescription(value);
        editProductForm.setValue('long_description', value);
    };

    const switchToRichEditor = () => {
        if (/<table[\s>]/i.test(longDescription)) {
            const ok = window.confirm(
                "L'editor visuale non supporta le tabelle HTML: passando a quell'editor la tabella verrà trasformata in testo e perderai la struttura. Continuare?"
            );
            if (!ok) return;
        }
        setDescriptionEditorMode('rich');
    };

    const quillModules = useMemo(
        () => ({
            toolbar: [
                [{ font: [] }],
                [{ size: [] }],
                [{ align: [] }],
                [{ color: [] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['bold', 'italic', 'underline', 'strike'],
                ['clean'],
            ],
        }),
        []
    );

    const handleChangeCategory= (selected : any) => {
        editProductForm.setValue('category_id', selected.value);
        setSelectedCategory(selected);
    };

    const handleChangeVendor = (selected: { value: number; label: string } | null) => {
        setSelectedVendor(selected);
        editProductForm.setValue('vendor_id', selected ? selected.value : null);
    };

    const handleChange = (event: any) => {
        setLoad(parseInt(event.target.value));
    };

    const goBack = () => {
        const queryParams = new URLSearchParams(window.location.search);
        window.location.href = `/offers?${queryParams.toString()}`;
        // navigate(`/offers?${queryParams.toString()}`);
    };

    const saveAndClose = () => {
        const customEvent = new CustomEvent('submit', {
            bubbles: true,
            detail: { close: true },
        });

        if (formRef.current) {
            formRef.current.dispatchEvent(customEvent);
        }
    };

    return (
        <div className='page-wrapper'>
            {/* {closeOfferModalToggler.isToggled && (
        <OfferCloseModal
          closeOfferModalToggler={closeOfferModalToggler}
          offer={offer}
        />
      )} */}

            <MyNavigator path={`/offers`} trigger={navigateNow} />
            {(!isMobile || menuToggler.isToggled) && <SideBar toggler={menuToggler} />}
            <div>
                {isMobile && <NavBar toggler={menuToggler} />}
                <div
                    className={`page-content ${isMobile && menuToggler.isToggled ? (menuToggler.isToggledSecondary ? 'slide-right' : 'slide-left') : ''}`}
                    style={{
                        maxWidth: isMobile ? '' : 'calc(100vw - 256px)',
                        minWidth: isMobile ? '' : '1105px',
                        marginLeft: isMobile ? (menuToggler.isToggled ? '256px' : '') : '256px',
                        // display: anyModalOpen && isMobile ? "none" : "",
                    }}
                >
                    {logMessage.isToggled && (
                        <LogMessage
                            text={{
                                subject: logMessage.message.subject,
                                other_text: logMessage.message.other_text,
                                complement: logMessage.message.complement,
                            }}
                            bgColor={logMessage.message.bgColor}
                        />
                    )}
                    <button className='modal-button' style={{ marginLeft: 20, marginRight: 'auto', marginBottom: 0 }} onClick={goBack}>
                        <p className='add-buttonText'>Indietro</p>
                    </button>
                    {/* <OfferCreateHeader
              shareToggler={sharedModalToggler}
              editToggler={editOfferModalToggler}
            />
            <OfferCreateSpecs /> */}
                   

                    {product ? (
                        <>
                            <form ref={formRef} style={{ maxWidth: 800, width: '100%', paddingTop: 30 }} onSubmit={editProductForm.handleSubmit(onProductSubmit)}>
                                <>
                                    <div
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '20px' : '',
                                            marginTop: isMobile ? '33px' : '',
                                        }}
                                    >
                                        <CustomInput
                                            title={'Nome prodotto'}
                                            name={'title'}
                                            width='100%'
                                            type='text'
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.title}
                                            constraints={{
                                                required: true,
                                            }}
                                        />
                                    </div>
                                    <div
                                        className='offer-create-modal-date-location-inputs-box'
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '20px' : '',
                                        }}
                                    >
                                        <CustomInput
                                            title={'Condizione'}
                                            name={'condition_id'}
                                            width='100%'
                                            type='select'
                                            options={conditions}
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.condition?.id}
                                            idValue={true}
                                            constraints={{
                                                required: false,
                                            }}
                                        />
                                        <Select
                                            name={'category_id'}
                                            options={categories}
                                            value={selectedCategory}
                                            required={false}
                                            isSearchable={true}
                                            styles={CustomStyle}
                                            onChange={handleChangeCategory}
                                        />
                                    </div>
                                    <div
                                        className='offer-create-modal-date-location-inputs-box'
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: '20px',
                                        }}
                                    >
                                        <CustomInput
                                            width='100%'
                                            title={'Prezzo di vendita'}
                                            name={'final_price'}
                                            type='text'
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.final_price}
                                        />
                                        <CustomInput
                                            width='100%'
                                            title={'Pagamento'}
                                            name={'payment_rule_id'}
                                            type='select'
                                            options={paymentRules}
                                            register={editProductForm.register}
                                            idValue={true}
                                            defaultValue={product.payment_rule?.id}
                                            errors={editProductForm.formState.errors}
                                        />
                                    </div>
                                    <div
                                        className='offer-create-modal-date-location-inputs-box'
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '20px' : '',
                                        }}
                                    >
                                        {/* <CustomInput
                                        width='100%'
                                        title={'Quantità'}
                                        name={'quantity'}
                                        type='text'
                                        register={editProductForm.register}
                                        errors={editProductForm.formState.errors}
                                        defaultValue={product.quantity}
                                    /> */}
                                        <CustomInput
                                            width='100%'
                                            title={'Peso'}
                                            name={'waist'}
                                            type='text'
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.waist}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '20px' : '',
                                        }}
                                    >
                                        <CustomInput
                                            width='100%'
                                            title={'Politica di reso'}
                                            name={'return_rule_id'}
                                            type='select'
                                            options={returnRules}
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.return_rule?.id}
                                            idValue={true}
                                        />
                                    </div>
                                    <div
                                        className='offer-create-modal-date-location-inputs-box'
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: '20px',
                                        }}
                                    >
                                        <CustomInput
                                            width='100%'
                                            title={'EAN'}
                                            name={'ean'}
                                            type='text'
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.ean}
                                        />
                                        <CustomInput
                                            width='100%'
                                            title={'brand'}
                                            name={'brand'}
                                            type='text'
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.brand}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '20px' : '',
                                            marginTop: isMobile ? '33px' : '33px',
                                        }}
                                    >
                                        {/* <CustomInput
                                        title={'Descrizione'}
                                        name={'long_description'}
                                        width='100%'
                                        height={300}
                                        type='textarea'
                                        register={editProductForm.register}
                                        errors={editProductForm.formState.errors}
                                        defaultValue={product.long_description}
                                        constraints={{
                                            required: true,
                                        }}
                                    /> */}
                                        <h3 className='user-table-header-title'>Descrizione</h3>
                                        <p style={{ fontSize: 13, color: '#555', marginTop: 6, marginBottom: 8 }}>
                                            Per descrizioni con <strong>tabelle HTML</strong> usa &quot;HTML sorgente&quot;: l&apos;editor visuale (Quill) non le supporta e le appiattisce in paragrafi.
                                        </p>
                                        <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                                            <button
                                                type='button'
                                                className='modal-button'
                                                style={{ margin: 0, opacity: descriptionEditorMode === 'rich' ? 1 : 0.65 }}
                                                onClick={switchToRichEditor}
                                            >
                                                <p className='add-buttonText' style={{ margin: 0 }}>
                                                    Editor visuale
                                                </p>
                                            </button>
                                            <button
                                                type='button'
                                                className='modal-button'
                                                style={{ margin: 0, opacity: descriptionEditorMode === 'html' ? 1 : 0.65 }}
                                                onClick={() => setDescriptionEditorMode('html')}
                                            >
                                                <p className='add-buttonText' style={{ margin: 0 }}>
                                                    HTML sorgente
                                                </p>
                                            </button>
                                        </div>
                                        {descriptionEditorMode === 'html' ? (
                                            <div style={{ marginBottom: 50, marginTop: 4 }}>
                                                <textarea
                                                    value={longDescription}
                                                    onChange={handleRawDescriptionChange}
                                                    spellCheck={false}
                                                    style={{
                                                        width: '100%',
                                                        minHeight: 280,
                                                        fontFamily: 'monospace',
                                                        fontSize: 13,
                                                        padding: 10,
                                                        boxSizing: 'border-box',
                                                        border: '1px solid #ccc',
                                                        borderRadius: 4,
                                                    }}
                                                />
                                                <p className='user-table-header-title' style={{ marginTop: 16, marginBottom: 8, fontSize: 15 }}>
                                                    Anteprima
                                                </p>
                                                <style>{`
                                                    .offer-details-long-desc-preview table { border-collapse: collapse; margin: 0 auto; }
                                                    .offer-details-long-desc-preview th,
                                                    .offer-details-long-desc-preview td { border: 1px solid #333; padding: 6px 10px; }
                                                `}</style>
                                                <div
                                                    className='offer-details-long-desc-preview'
                                                    style={{
                                                        border: '1px solid #ddd',
                                                        borderRadius: 4,
                                                        padding: 12,
                                                        maxHeight: 360,
                                                        overflow: 'auto',
                                                        background: '#fafafa',
                                                    }}
                                                    dangerouslySetInnerHTML={{ __html: longDescription }}
                                                />
                                            </div>
                                        ) : (
                                            <ReactQuill
                                                key={`quill-${sku}`}
                                                style={{ marginBottom: 50, marginTop: 10 }}
                                                theme='snow'
                                                value={longDescription}
                                                onChange={handleDescriptionChange}
                                                modules={quillModules}
                                            />
                                        )}
                                        <h3 className='user-table-header-title' style={{ marginBottom: 10 }}>
                                            Immagini
                                        </h3>
                                        <DragAndDropImages setValue={editProductForm.setValue} images={product.pictures} isEdit={true} />
                                        <div style={{ display: 'none' }}>
                                            <CustomInput
                                                title={'userId'}
                                                name={'user_id'}
                                                width='100%'
                                                height={100}
                                                type='text'
                                                register={editProductForm.register}
                                                errors={editProductForm.formState.errors}
                                                defaultValue={user?.id}
                                            />
                                        </div>
                                    </div>


                                    <CustomInput
                                        title={'Stato'}
                                        name='published'
                                        width='100%'
                                        type='select'
                                        options={product.published ? [{ name: 'Pubblicato', id: 1 }] : publishedOptions}
                                        register={editProductForm.register}
                                        errors={editProductForm.formState.errors}
                                        defaultValue={product.published ? 1 : 0}
                                        idValue={true}
                                    />

                                   

                                    <br/>
                                    <br/>
                                    <br/>
                                    <label htmlFor={'contovendita'}>Conto vendita:</label>
                                    <Select
                                            name={'supplier_id'}
                                            options={suppliers}
                                            value={selectedSupplier}
                                            required={false}
                                            isSearchable={true}
                                            styles={CustomStyle}
                                            onChange={handleChangeContoVendita}
                                    />

                                    {sites.length > 0 && (
                                        <div
                                            style={{
                                                gap: isMobile ? '20px' : '',
                                                marginTop: 50,
                                            }}
                                        >
                                            <h3 style={{ marginBottom: 20 }} className='user-table-header-title'>
                                                Siti
                                            </h3>
                                            {sites.map((item: any, i: number) => {
                                                return (
                                                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                                        <input value={item.id} type='checkbox' {...editProductForm.register(`sites.${item.id}`)} checked={sitesValues?.[item.id] || false} />
                                                        <p className='sidebar-user-info-name' style={{ margin: 0 }}>
                                                            {item.name}
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                    <div
                                        style={{
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '20px' : '',
                                        }}>

                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <h3 className='user-table-header-title'>Notes</h3>
                                        <CustomInput
                                            title={'Note'}
                                            name={'notes'}
                                            width='100%'
                                            type='text'
                                            register={editProductForm.register}
                                            errors={editProductForm.formState.errors}
                                            defaultValue={product.notes}
                                            constraints={{
                                                required: false,
                                            }}
                                        />
                                    </div>
                                    <div style={{ marginTop: 20 }}>
                                        <p className='customInputText-title' style={{ marginBottom: 8 }}>Vendor</p>
                                        <Select
                                            options={vendors}
                                            value={selectedVendor}
                                            isClearable
                                            isSearchable
                                            placeholder='Seleziona vendor'
                                            styles={CustomStyle}
                                            onChange={handleChangeVendor}
                                        />
                                    </div>

                                </>
                                <div style={{ width: '100%', maxWidth: 800, marginTop: 50 }}>
                                    <h3 className='user-table-header-title'>Quantità</h3>
                                    <p className='user-card-field'>{quantity}</p>
                                    <div>
                                        {movements && movements.length > 0 && (
                                            <>
                                                <p className='user-table-header-title' style={{ marginTop: 30 }}>
                                                    Movimenti
                                                </p>
                                                <div className='movements'>
                                                    <p style={{ width: 'fit-content', marginTop: 10, marginBottom: 10 }} className='sidebar-user-info-name'>
                                                        ID
                                                    </p>
                                                    <p style={{ width: 'fit-content', marginTop: 10, marginBottom: 10 }} className='sidebar-user-info-name'>
                                                        Quantità
                                                    </p>
                                                    <p style={{ width: 'fit-content', marginTop: 10, marginBottom: 10 }} className='sidebar-user-info-name'>
                                                        Data creazione
                                                    </p>
                                                    <p style={{ width: 'fit-content', marginTop: 10, marginBottom: 10 }} className='sidebar-user-info-name'>
                                                        Note
                                                    </p>
                                                </div>
                                                {movements.map((item: any, i: number) => {
                                                    const date = new Date(item.created_at);
                                                    const formatted = date.toLocaleDateString('it-IT', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        second: '2-digit',
                                                        timeZone: 'Europe/Rome',
                                                    });
                                                    return (
                                                        <div key={i} className='movements'>
                                                            <p className='user-card-field'>{item.id}</p>
                                                            <p className='user-card-field'>{item.quantity}</p>
                                                            <p className='user-card-field'>{formatted}</p>
                                                            <p className='user-card-field'>{item.notes}</p>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                    <div style={{ width: 130 }} className='modal-button' onClick={() => setPopupMovements(true)}>
                                        <p className='add-buttonText'>Crea movimento</p>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20, paddingTop: 30 }}>
                                    {isSavingProduct ? (
                                        <Loader />
                                    ) : (
                                        <>
                                            <button style={{ width: 150, margin: 0 }} className='modal-button' onClick={saveAndClose}>
                                                <p className='add-buttonText'>Salva e chiudi</p>
                                            </button>
                                            <button style={{ width: 150, margin: 0 }} className='modal-button' type='submit'>
                                                <p className='add-buttonText'>Salva prodotto</p>
                                            </button>
                                        </>
                                    )}
                                    {isCloningProduct ? (
                                        <Loader />
                                    ) : (
                                        <div style={{ width: 120, margin: 0 }} className='modal-button' onClick={cloneProduct}>
                                            <p className='add-buttonText'>Clona prodotto</p>
                                        </div>
                                    )}
                                    {isDeletingProduct ? (
                                        <Loader />
                                    ) : (
                                        <div
                                            className='modal-button'
                                            style={{
                                                margin: 0,
                                                background: 'red',
                                                color: 'white',
                                                opacity: quantity === 0 ? 1 : 0.3,
                                                pointerEvents: quantity === 0 ? 'unset' : 'none',
                                            }}
                                            onClick={deleteProduct}
                                        >
                                            <p className='add-buttonText'>Elimina prodotto</p>
                                        </div>
                                    )}
                                </div>
                            </form>
                            {popupMovements && (
                                <CustomModal title='Crea movimento' description='' setShow={setPopupMovements}>
                                    <form style={{ width: '100%' }} onSubmit={editMovementsForm.handleSubmit(onMovementsSubmit)}>
                                        <div className='load'>
                                            <div>
                                                <input type='radio' name='load' value={1} checked={load === 1} onChange={handleChange} />
                                                <label className='user-card-field'>Carico</label>
                                            </div>
                                            <div>
                                                <input type='radio' name='load' value={0} checked={load === 0} onChange={handleChange} />
                                                <label className='user-card-field'>Scarico</label>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <p style={{ marginTop: 32, width: 15, fontSize: 20 }} className='client-details-card-info-spec-value'>
                                                {load === 1 ? '+' : '-'}
                                            </p>
                                            <CustomInput
                                                width='100%'
                                                title={'Quantità'}
                                                name={'quantity'}
                                                type='text'
                                                register={editMovementsForm.register}
                                                errors={editMovementsForm.formState.errors}
                                                defaultValue={'0'}
                                            />
                                            <br></br>
                                            <br></br>
                                            <br></br>
                                            <CustomInput
                                                width='100%'
                                                title={'Note'}
                                                name={'notes'}
                                                type='textarea'
                                                register={editMovementsForm.register}
                                                errors={editMovementsForm.formState.errors}
                                                defaultValue={''}
                                                constraints={{
                                                    required: false,
                                                }}
                                            />
                                        </div>
                                        {isLoadingMovements ? (
                                            <Loader />
                                        ) : (
                                            <>
                                                <button style={{ width: 120 }} className='modal-button' type='submit'>
                                                    <p className='add-buttonText'>Salva</p>
                                                </button>
                                            </>
                                        )}
                                    </form>
                                </CustomModal>
                            )}
                            <button className='modal-button' style={{ marginLeft: 20, marginRight: 'auto', marginBottom: 0 }} onClick={goBack}>
                                <p className='add-buttonText'>Indietro</p>
                            </button>
                        </>
                    ) : (
                        <Loader />
                    )}
                </div>
            </div>
        </div>
    );
};
export default OfferDetailsPage;
